import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import NumberFormat from 'react-number-format';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'react-i18next';

import {validate1 as validate} from './validate';
import ButtonValidation from './button_validation';

const numberSeparator = ' ';

const formNamesAll ={
  2: {
    revenues: "revenues1",
    ebit:'ebit1',
    interests: 'interests1',
    others:'others1',
    netIncome: 'netIncome1',
    year:0
  },
  3: {
    revenues: "revenues2",
    ebit:'ebit2',
    interests: 'interests2',
    others:'others2',
    netIncome: 'netIncome2',
    year:1
  },
  4: {
    revenues: "revenues3",
    ebit:'ebit3',
    interests: 'interests3',
    others:'others3',
    netIncome: 'netIncome3',
    year:2
  },
};

const styles = theme => ({
  textField: {
    width: '100%',
  },
  title:{
    fontWeight: 'bold',
    marginBottom:theme.spacing.unit
  }
});


function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator={numberSeparator}
    />
  );
}
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

function FormattedInputs (props) {
  const { input, classes, currency, label, meta: { touched, error } } = props;

  var value = ''
  if (input && input.value ){
    if( input.value.target && input.value.target.value ){
      value = input.value.target.value;
    }
    else {
      value = input.value;
    }
    if (value !== '' ){
      value = Number(value.toString().split(numberSeparator).join(""));
    }
  }
  return (
      <TextField
        {...input}
        label={label}
        className={classes.textField}
        margin="normal"
        variant="outlined"
        error={(touched && error?true:false)} 
        helperText={(touched && error)?error:""}  

        value={value}
        onChange={input.onChange(value)}

        InputProps={{
          endAdornment: <InputAdornment position="end">{currency}</InputAdornment>,
          inputComponent: NumberFormatCustom,
        }}
      />
  );
}

FormattedInputs.propTypes = {
  classes: PropTypes.object.isRequired,
};

function FormEstimationFinancials(props) {

	const { t } = useTranslation();

  const { handleSubmit, index, classes, formUse} = props;  
  const formNames = formNamesAll[index]; 
  const year = props.formUse.values.latestYear.value - formNames.year;

  var currency='';
  if (formUse && formUse.values && formUse.values.currency && formUse.values.currency.value){
    currency = props.formUse.values.currency.value;
  }

  // console.log(props);

  return (
    <form onSubmit={handleSubmit}>
      <Typography variant="h5" className={classes.title}>{`${t('data_label')} ${year}`}</Typography>
      <Grid container spacing={8}>
        <Grid item xs={12}>
          <Field
              label={`${t('turnover_label')} ${year}*`}
              name={formNames.revenues}
              component={FormattedInputs} 
              classes={classes}
              currency={currency}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
              label={`${t('operating_result_label')} ${year}*`}
              name={formNames.ebit}
              component={FormattedInputs} 
              classes={classes}
              currency={currency}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
              label={`${t('net_profit_label')} ${year}*`}
              name={formNames.netIncome}
              component={FormattedInputs} 
              classes={classes}
              currency={currency}
          />
        </Grid>
        <Grid item xs={12}>
          <ButtonValidation 
          activeStep = {props.activeStep}
          handleBack = {props.handleBack} 
          steps  = {props.steps} 
          invalid = {props.invalid}
           />
        </Grid>
      </Grid>
    </form> 
  );
}

function mapStateToProps(state){
  return { 
    formUse: state.form.formEstimation,
  };
}
FormEstimationFinancials =  withStyles(styles)(FormEstimationFinancials);

export default connect(mapStateToProps)(FormEstimationFinancials);